<template>
  <div></div>
</template>

<script>
import Echo from "laravel-echo";

export default {
  name: "EdSocket",
  components: {},
  data: () => ({}),
  mounted() {},
  computed: {},
  methods: {
    inicialize() {
      if (!window.Echo) {
        let host = process.env.URL_SOCKET;

        if (!process.env.PRODUCTION) {
          host = "http://" + window.location.hostname;
        }

        window.io = require("socket.io-client");
        window.Echo = new Echo({
          broadcaster: "socket.io",
          encrypted: true,
          key: process.env.SOCKET_KEY,
          host: host,
          auth: {
            headers: {},
          },
        });
      }
    },

    publicChannel(_channel) {
      this.inicialize();
      return window.Echo.channel(this.$root.$session.getClienteLogado.id+'.'+_channel);
    },

    privateChannel(_channel) {
      this.inicialize();
      if(!this.$root.$session.getUsuarioLogado)return null;

      return window.Echo.private(this.$root.$session.getClienteLogado.id+'.'+_channel);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/root/EdSocket.vue